import React from "react";
import { HOME_WHAT_WE_DO } from "../../content/siteContent";

export const AboutOne = () => {
  return (
    <section className="about-area about-bg">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5">
            <div className="about-img-wrap">
              <img src="/images/home/team-consultation.webp" alt="Zawix Business Consultants team reviewing client documents" className="main-img" />
              <img src="/images/home/dots.png" alt="" />
              <img src="/images/home/dots.png" alt="" />
            </div>
          </div>
          <div className="col-lg-7">
            <div className="about-content">
              <div className="section-title mb-25 tg-heading-subheading animation-style2">
                <span className="sub-title tg-element-title">What We Do</span>
                <h2 className="title tg-element-title">
                  Transforming Business Setup & Compliance
                </h2>
              </div>
              <p>
                We help businesses move through setup, registration,
                compliance, and approvals with practical guidance and reliable
                execution.
              </p>
              <ul className="list-wrap mt-4">
                {HOME_WHAT_WE_DO.slice(0, 3).map((item) => (
                  <li key={item.id} className="mb-2">
                    <strong>{item.title}:</strong> {item.list.join(" | ")}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
